module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "nav"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "tocfm",
    attrs: {
      "id": "ncover"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/cover#cover"
    }
  }, [_vm._v(" Cover")])]), _vm._v(" "), _c('li', {
    staticClass: "tocfm",
    attrs: {
      "id": "ntitle-page"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/title_page#title-page"
    }
  }, [_vm._v(" Title Page")])]), _vm._v(" "), _c('li', {
    staticClass: "tocfm",
    attrs: {
      "id": "nde1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Dedication#de1"
    }
  }, [_vm._v(" Dedication")])]), _vm._v(" "), _c('li', {
    staticClass: "tocnav",
    attrs: {
      "hidden": "hidden"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/nav"
    }
  }, [_vm._v(" Contents")])]), _vm._v(" "), _c('li', {
    staticClass: "tocfm",
    attrs: {
      "id": "nin4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction#in4"
    }
  }, [_vm._v(" Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "tocfm",
    attrs: {
      "id": "nfo2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Foreword#fo2"
    }
  }, [_vm._v(" Foreword")])]), _vm._v(" "), _c('li', {
    staticClass: "tocfm",
    attrs: {
      "id": "npr3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Prologue#pr3"
    }
  }, [_vm._v(" Prologue")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_p",
    attrs: {
      "id": "npa5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Part_I#pa5"
    }
  }, [_vm._v(" Part I: Memphis Wonderland")]), _c('ol', [_c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1_Mother_Dear_Ma#ch6"
    }
  }, [_vm._v(" 1: Mother Dear, Mama, and Me")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter_2_As_I_Yearn_So#ch7"
    }
  }, [_vm._v(" 2: As I Yearn, So I Learn")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter_3_Ill_Never_Los#ch8"
    }
  }, [_vm._v(" 3: I’ll Never Lose Chicago Blues")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_4_The_Chess_Less#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 4: The Chess Lessons")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_5_The_Ramsey_Lew#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 5: The Ramsey Lewis Trio")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_6_The_World_Can#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 6: The World Can’t Erase My Fantasy")])])])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_p",
    attrs: {
      "id": "npa12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Part_II#pa12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Part II: Between the Vision and the Fulfillment")]), _c('ol', [_c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_7_Starting_from_#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 7: Starting from Scratch")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_8_Hearts_of_Fire#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 8: Hearts of Fire, New Desire")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_9_Trusting_in_th#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 9: Trusting in the Process")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_10_Step#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 10: Step")])])])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_p",
    attrs: {
      "id": "npa17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Part_III#pa17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Part III: To Sing Our Message Loud and Clear")]), _c('ol', [_c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_11_True_Pride#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 11: True Pride")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_12_Accepting_Lif#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 12: Accepting Life")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_13_Thats_the_Wa#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 13: That’s the Way of the World")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_14_Expansion#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 14: Expansion")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_15_Gratitude#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 15: Gratitude")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_16_Departure#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 16: Departure")])])])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_p",
    attrs: {
      "id": "npa24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Part_IV#pa24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Part IV: Full-Spectrum Music")]), _c('ol', [_c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_17_Musical_and_S#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 17: Musical and Spiritual Progressives")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_18_The_Best_of_M#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 18: The Best of My Love at the Best of Times")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_19_All_N_All#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 19: All ’N All")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_20_Musical_Theat#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 20: Musical Theater, Magical Tour")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_21_Beginnings_an#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 21: Beginnings and Endings")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_22_A_Hell_of_a_L#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 22: A Hell of a Left Hand")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_23_I_Am#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 23: I Am")])])])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_p",
    attrs: {
      "id": "npa32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Part_V#pa32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Part V: The Changing Times")]), _c('ol', [_c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_24_All_in_the_Cr#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 24: All in the Creator’s Hands")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_25_Dont_Make_My#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 25: Don’t Make My Band Your Crusade")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_26_The_Groove#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 26: The Groove")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_27_Black_Tax#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 27: Black Tax")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_28_Somethings_G#ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 28: Something’s Got to Give")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_29_On_the_Solo#ch38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 29: On the Solo")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_30_Blindsided#ch39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 30: Blindsided")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_31_Not_Fitting_I#ch40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 31: Not Fitting In")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_32_A_Time_of_Sym#ch41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 32: A Time of Symbolism")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_33_Letting_Go#ch42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 33: Letting Go")])])])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_p",
    attrs: {
      "id": "npa43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Part_VI#pa43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Part VI: Contemplation")]), _c('ol', [_c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_34_Time_Will_Wit#ch44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 34: Time Will Witness What the Old Folks Say")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "nch45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_35_When_My_Final#ch45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 35: When My Final Song Is Sung")])])])]), _vm._v(" "), _c('li', {
    staticClass: "tocrm",
    attrs: {
      "id": "naf54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Afterword#af54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Afterword")])]), _vm._v(" "), _c('li', {
    staticClass: "tocrm",
    attrs: {
      "id": "nac47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Acknowledgments#ac47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Acknowledgments")])]), _vm._v(" "), _c('li', {
    staticClass: "tocrm",
    attrs: {
      "id": "npe46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Permissions#pe46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Permissions")])]), _vm._v(" "), _c('li', {
    staticClass: "tocrm",
    attrs: {
      "id": "nin48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Index#in48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Index")])]), _vm._v(" "), _c('li', {
    staticClass: "tocrm",
    attrs: {
      "id": "nphoto"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Photo_Insert",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Photos")])]), _vm._v(" "), _c('li', {
    staticClass: "tocrm",
    attrs: {
      "id": "nab49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/About_the_Author#ab49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" About the Author")])]), _vm._v(" "), _c('li', {
    staticClass: "tocrm",
    attrs: {
      "id": "nco52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Copyright_ebook#co52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Copyright")])]), _vm._v(" "), _c('li', {
    staticClass: "tocrm",
    attrs: {
      "id": "nab53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/About_the_Publisher#ab53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" About the Publisher")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-206d183d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 66
// module chunks = 0